module.exports = __webpack_public_path__ + "img/tutorial_calendar_03.bfe7bcbe.gif";